import {SimilarListingsServiceQuery} from "../../serp/services/SimilarListingsServiceQuery";

export interface ListingsRepository {
    getSimilarListings(query: SimilarListingsServiceQuery): Promise<string>;
}

export class ApiListingsRepository implements ListingsRepository {
    public async getSimilarListings(query: SimilarListingsServiceQuery): Promise<string> {
        const apiUrl = this.buildApiUrlWithQueryParams(`/wl/api/v1/listings/${query.listingId}/similar`);
        return fetch(apiUrl.toString(), {
            method: 'POST',
            headers: {'Content-Type': 'application/json',},
            body: JSON.stringify({
                pageViewId: query.pageViewId,
                excludeListings: query.excludeListings,
                typeId: query.type,
                geoId: query.geoId,
                currentOrigin: query.currentOrigin,
                slug: query.slug,
            }),
        }).then((response) => response.text());
    }

    private buildApiUrlWithQueryParams(baseURL: string): URL {
        const currentUrl = new URL(window.location.href);
        const queryParams = currentUrl.searchParams;
        const apiUrl = new URL(baseURL, window.location.origin);
        queryParams.forEach((value, key) => {
            apiUrl.searchParams.append(key, value);
        });
        return apiUrl;
    }
}